 <h2 mat-dialog-title>Incomplete Rows</h2>
    <mat-dialog-content>
      <p>The following product IDs have incomplete fields and will not be saved:</p>
      <ul>
        <strong><li *ngFor="let id of data.productIds">{{ id }}</li></strong>
      </ul>
      <p>Do you want to continue?</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button class="reset" mat-dialog-close>No</button>
      <button class="btn" [mat-dialog-close]="true">Yes</button>
    </mat-dialog-actions>